import { TicketItemStatus as p } from "@ancon/wildcat-types";
import s from "./getCheckOrderMinimumStatusTicketItem.mjs";
import "./getMultiProductSubProductsTicketItems.mjs";
import "../toString-3b91b335.mjs";
import "../isArray-0d9c7aaa.mjs";
import "../_baseIteratee-4c4d0995.mjs";
import "../_getTag-4e44633b.mjs";
import "../_baseIsEqual-12d01a44.mjs";
import "../identity-6eafe87b.mjs";
function y(m) {
  return m.reduce(
    (t, e) => {
      const r = s(e);
      switch (r == null ? void 0 : r.status) {
        case p.Ready:
          t.ready.push(e);
          break;
        case p.Closed:
          t.done.push(e);
          break;
      }
      return t;
    },
    {
      all: m,
      ready: [],
      done: []
    }
  );
}
export {
  y as default
};
